import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';

import { AgreementCheckboxStateType } from '../AgreementCheckboxWrapper.hook';
import { Tooltip } from '../../../BaseComponents';
import { useTheme } from '../../../theme';

interface Props extends AgreementCheckboxStateType, Pick<CheckboxProps, 'classes'> {
	showTooltip?: boolean;
	onChange: (fieldName: string) => void;
}

const AgreementCheckbox: React.FunctionComponent<Props> = ({
	showTooltip,
	tooltipTitle,
	classes,
	fieldName,
	checked,
	label,
	required,
	onChange
}) => {
	const { AgreementCheckbox: css } = useTheme('AgreementCheckboxWrapper');

	const openTooltip = showTooltip && !checked && required && !!tooltipTitle;

	return (
		<FormControlLabel
			control={
				<Tooltip open={openTooltip} title={tooltipTitle} placement="top-start">
					<Checkbox
						color="primary"
						classes={{
							root: css.checkbox,
							checked: css.checkbox_checked
						}}
						checked={checked}
						onClick={() => onChange(fieldName)}
					/>
				</Tooltip>
			}
			value={checked}
			label={label}
		/>
	);
};

export default AgreementCheckbox;
